import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import useAuth from '../hooks/useAuth';

const BANNER_HEIGHT = 40;

export default function ImpersonationBanner() {
  const { impersonation, user, exitImpersonation } = useAuth();
  const navigate = useNavigate();

  const handleExit = useCallback(async () => {
    await exitImpersonation();
    navigate('/dashboard/admin/users');
  }, [exitImpersonation, navigate]);

  if (!impersonation.isImpersonating) return null;

  const displayName =
    user?.firstName || user?.first_name
      ? `${user.firstName ?? user.first_name} ${user.lastName ?? user.last_name}`.trim()
      : user?.email ?? 'another user';

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        height: BANNER_HEIGHT,
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2,
        bgcolor: 'warning.main',
        color: 'warning.contrastText',
        px: 2,
      }}
    >
      <Typography variant="body2" fontWeight={600}>
        You are viewing as {displayName} ({user?.role})
      </Typography>
      <Button
        size="small"
        variant="contained"
        color="error"
        onClick={handleExit}
        sx={{ minHeight: 26, py: 0, px: 2, fontSize: '0.75rem' }}
      >
        Exit
      </Button>
    </Box>
  );
}

export { BANNER_HEIGHT };
